import { render, staticRenderFns } from "./NurseCallHistory.vue?vue&type=template&id=2ee8e63d&scoped=true"
import script from "./NurseCallHistory.vue?vue&type=script&lang=js"
export * from "./NurseCallHistory.vue?vue&type=script&lang=js"
import style0 from "./NurseCallHistory.vue?vue&type=style&index=0&id=2ee8e63d&prod&scoped=true&lang=css"
import style1 from "./NurseCallHistory.vue?vue&type=style&index=1&id=2ee8e63d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8e63d",
  null
  
)

export default component.exports